/**
 * Leitura de variável do Vite por nome CALCULADO.
 *
 * As feature flags resolvem a chave a partir do nome lógico da flag, então o
 * acesso não pode ser estático. O `vite/client` tipa esse acesso como `any`;
 * aqui ele é estreitado para `string | undefined` num ponto único, em vez de o
 * `any` vazar para cada chamador.
 *
 * A referência a `import.meta.env` precisa continuar ESTÁTICA: é ela que faz o
 * Vite injetar o objeto de env no módulo. Escrita como acesso dinâmico, a
 * injeção não acontece e toda leitura devolve `undefined`.
 */
export function readViteEnv(name: string): string | undefined {
  const env = import.meta.env as unknown as Record<string, unknown>;
  const value = env[name];
  return typeof value === 'string' ? value : undefined;
}
